import { createApp, markRaw } from 'vue/dist/vue.esm-bundler.js'
import App from './App.vue'
import axios from 'axios'
import VueAxios from 'vue-axios'

import router from './router'

import { createPinia } from 'pinia'

const pinia = createPinia()
pinia.use(({ store }) => {
	store.router = markRaw(router)
})

//Redirec to login on protected pages for guests
import { guestRedirect } from '@/interceptors/guestRedirect.js'
router.beforeEach(guestRedirect)

import { addAuthorizationHeader } from '@/interceptors/addAuthorizationHeader.js'
import { handleUnauthorizedResponse } from '@/interceptors/handleUnauthorizedResponse.js'

axios.interceptors.request.use(addAuthorizationHeader)
axios.interceptors.response.use(
	(response) => {
		return response
	}, handleUnauthorizedResponse
)

import apiBaseMixin from './mixins/apiBaseMixin'

createApp(App).mixin(apiBaseMixin)
    .use(pinia)
    .use(router)
    .use(VueAxios, axios)
    .mount('#app')
